
<div
  class="rounded-lg overflow-hidden bg-white shadow-lg"
  :class="[usePadding ? 'p-8' : '']"
>
  <slot></slot>
</div>
